import { Form } from 'react-router-dom'
import React, { useState, useContext, useEffect } from 'react';
import Application from "../../../StateContext/Application";
const CreateDepartment = () => {
    const [Department, SetDepartment] = useState('');
    const [options, setOptions] = useState([]);
    const [show, setshow] = useState(true)
    const [menu, setmenu] = useState([])
    
    const statecalls = useContext(Application);
    const { Usermenu, DepartmentHandler } = statecalls;

    useEffect(() => {
        async function getmenus() {
            try {
                let menu = await Usermenu();
                console.log("menu",menu);
                
                setOptions(Array.isArray(menu.result) ? menu.result : []);
            } catch (error) {
                console.error(error);
            }
        }
        getmenus()
    }, [])

    async function objectpusher(ev, menuname) {
        try {
            if (ev.checked) {
                menu.push(menuname);
            } else {
                let menuarray = []
                menu.forEach((e) => {
                    if (e !== menuname) {
                        menuarray.push(e);
                    }
                });
                setmenu(menuarray);
            }
        } catch (error) {
            console.error(error);
        }
    }


    const CreateDepartment = async () => {
        try {
            let condition = await DepartmentHandler('insert', Department, menu);
            setshow(condition);
            alert("Department Created Successfully")
        } catch (error) {
            console.error(error);
        }
    }
    return (
        <div>
            <h5 style={{ textAlign: 'center' }}>CreateDepartment</h5>
            <Form onSubmit={CreateDepartment} className='mx-5'>
                <div>
                    <label>Department Name</label>
                    <br></br>
                    <input type='text' onChange={(e) => SetDepartment(e.target.value)} placeholder='Enter Department Name Here' required className='form-control my-3'></input>
                </div>
                {show ? options?.map((e,index) => {
                    if (e.Summenuid === 0) {
                        return (
                            <>
                                <div key={index} className="accordion" id="accordionPanelsStayOpenExample">
                                    <div className="accordion-item" >
                                        <h2 className="accordion-header" id="panelsStayOpen-headingOne">
                                            <button style={{ backgroundColor: '#cfe2ff' }} className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true" aria-controls="panelsStayOpen-collapseOne">
                                                {e.Menu_Name}
                                            </button>
                                        </h2>
                                        <b>{e.Menu_Name}</b>
                                        <div style={{ display: 'flex' }}>
                                            <span className='mx-2'><b>Access Rights</b><input type='checkbox' onClick={(ev) => objectpusher(ev.currentTarget, e.Menu_ID)} /></span>
                                        </div>
                                        <div id="panelsStayOpen-collapseOne" className="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingOne">
                                            <div className="accordion-body">
                                                {options?.map((x,index) => {
                                                    if (e.Menu_ID === x.Summenuid) {
                                                        return (
                                                            <div key={index} style={{ backgroundColor: 'lemonchiffon', border: 'black 2px solid' }}>
                                                                <label> {x.Menu_Name}</label>
                                                                <div style={{ display: 'flex' }}>
                                                                    <span className='mx-2'><b>Access Right</b><input type='checkbox' onClick={(ev) => objectpusher(ev.currentTarget, x.Menu_ID)} /></span>
                                                                </div>
                                                            </div>
                                                        )
                                                    }

                                                })}


                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br />
                            </>
                        )
                    }

                }
                ) : null}
                <button className='btn btn-success form-control' style={{backgroundColor:"rgb(10, 200, 150) ",border:"none",borderRadius:"10px"}}>Submit</button>
            </Form>
        </div>
    )
}

export default CreateDepartment